import { NETWORK_VIEW_IDS } from '@nile/rmm/src/snmp/helpers';

const getAlertViewsConfig = () => {
  return {
    header: 'asset.sidebar.alerts',
    list: [],
    icon: {
      type: 'supericon',
      name: 'AlertIcon',
      color: 'red'
    },
    route: {
      baseRoute: '/rmm/alert/',
      accessors: ['id']
    },
    addOption: true,
    roleToCheck: 'alertView.add'
  };
};

const getPatchViewsConfig = () => {
  return {
    header: 'asset.sidebar.patch',
    list: [],
    icon: {
      type: 'supericon',
      name: 'PatchLight',
      color: '#307152'
    },
    route: {
      baseRoute: '/rmm/patch/',
      accessors: ['id']
    },
    addOption: true,
    roleToCheck: 'patchViews.add'
  };
};

const getAssetViewsConfig = () => {
  return {
    header: 'asset.sidebar.assetViews',
    list: [],
    icon: {
      type: 'supericon',
      name: 'AssetGroup',
      color: '#AE39B2'
    },
    route: {
      baseRoute: '/rmm/asset-view/',
      accessors: ['id']
    },
    addOption: true,
    roleToCheck: 'assetViews.add'
  };
};
const getRequesterAssetViewsConfig = () => {
  return {
    header: 'asset.sidebar.assetViews',
    list: [],
    icon: {
      type: 'supericon',
      name: 'AssetGroup',
      color: '#AE39B2'
    },
    route: {
      baseRoute: '/client/rmm/asset-view/',
      accessors: ['id']
    },
    addOption: false
  };
};

const getDashboardViewsConfig = () => {
  return {
    header: 'attribute.overviews',
    list: [],
    icon: {
      type: 'supericon',
      name: 'AssetGroup',
      color: '#AE39B2'
    },
    route: {
      baseRoute: '/rmm/maintenance-mode/',
      accessors: ['id']
    },
    addOption: false,
    roleToCheck: 'assetViews.add'
  };
};

const getDeviceCategoryConfig = () => {
  return {
    header: 'admin.deviceCategory.header',
    list: [],
    icon: {
      type: 'supericon',
      name: 'AssetGroup',
      color: '#AE39B2'
    },
    route: {
      baseRoute: '/rmm/device-category/',
      accessors: ['id']
    },
    addOption: true,
    addIcon: 'DiscoveredAssets',
    roleToCheck: 'assetViews.add'
  };
};

const getNetworkViewsConfig = () => {
  return {
    header: 'snmp.network.monitoring',
    list: [],
    icon: {
      type: 'supericon',
      name: 'NetworkAdapters',
      color: '#AE39B2'
    },
    route: {
      baseRoute: '/rmm/network-view/',
      accessors: ['id']
    },
    addOption: false,
    roleToCheck: 'assetViews.add'
  };
};

const networkMonitorIcons = {
  [NETWORK_VIEW_IDS.probe]: 'Chip',
  [NETWORK_VIEW_IDS.networkScan]: 'ScanNetwork',
  [NETWORK_VIEW_IDS.discoverAsset]: 'DiscoveredAssets'
};

const getAssetGroupViewsConfig = () => {
  return {
    header: 'asset.sidebar.assetGrp',
    list: [],
    icon: {
      type: 'assetType',
      variant: 'dark'
    },
    route: {
      baseRoute: '/rmm/asset-group/',
      accessors: ['groupId']
    },
    addOption: true,
    roleToCheck: 'assetGroup.add'
  };
};

const getScriptViewsConfig = () => {
  return {
    header: 'asset.sidebar.scripts',
    list: [],
    icon: {
      type: 'svg',
      fileName: 'script-light-icon.svg'
    },
    route: {
      baseRoute: '/rmm/script/',
      accessors: ['id']
    },
    addOption: false
  };
};

const getMonicaAIViewsConfig = () => {
  return {
    addIcon: 'Add',
    addOption: false,
    roleToCheck: 'monicaAi.add',
    list: [
      {
        id: 'review-queue',
        name: 'Review Queue',
        icon: '📈',
        route: '/rmm/monica-ai/review-queue',
        viewSubType: null,
        systemViewProperty: null,
        shared: false,
        customView: false
      },
      {
        id: 'monica-insights',
        name: 'Insights',
        icon: '💫',
        route: '/rmm/monica-ai/monica-insights',
        viewSubType: null,
        systemViewProperty: null,
        shared: false,
        customView: false
      }
    ],
    header: 'Monica AI',
    tooltip: 'Monica AI'
  };
};

export {
  getAlertViewsConfig,
  getPatchViewsConfig,
  getAssetViewsConfig,
  getAssetGroupViewsConfig,
  getScriptViewsConfig,
  getNetworkViewsConfig,
  getDashboardViewsConfig,
  getDeviceCategoryConfig,
  getRequesterAssetViewsConfig,
  networkMonitorIcons,
  getMonicaAIViewsConfig
};
